<div
    class="popover-wrapper"
    [ngClass]="{
        'popover-completed-step': step.State === stepStateEnum.Completed,
    }"
>
    <div class="popover-title bold-text" data-uiid="new-eff-popover-step-name">
        {{ step.NameKey | t }}
    </div>
    <div class="popover-content">
        @if (step.State !== stepStateEnum.Completed) {
            <div class="table-row" data-uiid="new-eff-popover-assignees">
                <div class="table-cell bold-text">{{ 'effWorkflowPopover.assignees' | t }}</div>
                <div class="table-cell">
                    <div class="d-flex flex-column assigned-persons-wrapper">
                        @for (user of step.AssignedUsers; track user) {
                            <div>
                                {{ user }}
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
        @if (step.State === stepStateEnum.Completed) {
            <div class="table-row" data-uiid="new-eff-popover-completed-by">
                <div class="table-cell bold-text">{{ 'effWorkflowPopover.completedBy' | t }}</div>
                <div class="table-cell">{{ step.CompletedBy }}</div>
            </div>

            <div class="table-row" data-uiid="new-eff-popover-date-completed">
                <div class="table-cell bold-text">{{ 'effWorkflowPopover.dateCompleted' | t }}</div>
                <div class="table-cell">{{ step.CompletedOn }}</div>
            </div>
        }
        <div class="table-row" data-uiid="new-eff-popover-due-date">
            <div class="table-cell bold-text">{{ 'effWorkflowPopover.dueDate' | t }}</div>
            <div class="table-cell">{{ step.DueDate }}</div>
        </div>
    </div>
</div>
